import { WIDGET } from '@voltmoney/schema';
import { LAYOUTS, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { api } from '../../configs/api';
import { getAppHeader } from '../../configs/config';
import SharedPropsService from '../../SharedPropsService';
export const template = (height) => ({
    layout: {
        id: ROUTE.ELEVATE_LANDING,
        type: LAYOUTS.LIST,
        widgets: [
            {
                id: 'elevateSwitching',
                type: WIDGET.ELEVATE_SWITCHING,
            },
        ],
    },
    datastore: {
        elevateSwitching: {
            height: height,
            switchingResponse: 'PENDING',
            switchedTo: ""
        },
    },
});
export const elevateSwitchingMF = {
    onLoad: async ({ network, getHeight, setDatastore, navigate }, { targetCreditId }) => {
        const userData = await SharedPropsService.getUser();
        const accountId = userData.linkedApplications[0].accountId;
        const header = await getAppHeader();
        const response = await network.post(api.switchCredit, {
            accountId: accountId,
            updatedCreditId: targetCreditId,
        }, { headers: header, handleFromMF: true }, async () => {
            return;
        }, {});
        if (response.status === 200) {
            setTimeout(async () => {
                await setDatastore(ROUTE.ELEVATE_SWITCHING, 'elevateSwitching', {
                    switchingResponse: "SUCCESS",
                    switchedTo: response.data?.lendingPartnerId
                });
                // show the success state animation only after for 2 seconds
                setTimeout(async () => {
                    await navigate(ROUTE.DASHBOARD);
                }, 2000);
                // show the main loader for atleast 2s
            }, 2000);
        }
        else {
            setTimeout(async () => {
                await setDatastore(ROUTE.ELEVATE_SWITCHING, 'elevateSwitching', {
                    switchingResponse: "FAILURE",
                });
                // show the failure state animation only after for 2 seconds
                setTimeout(async () => {
                    await navigate(ROUTE.DASHBOARD);
                }, 2000);
                // show the main loader for atleast 2s
            }, 2000);
        }
        return Promise.resolve(template(getHeight()));
    },
    actions: {},
};
